
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import { addRemark } from "@/api/hengan-loading-plan";
import { updateContainerTypeRemark } from "@/api/container-type";

@Component({
  name: "ContainerTypeReleasedInfo"
})

export default class extends Vue {

  @Prop({ required: true }) readonly data!: ContainerTypeReleasedInfoModel;
  @Prop({ required: true }) private loadingPlanType: string;
  private headerInfo: HeaderInfo = new HeaderInfo();
  private unreleasedContainerTypes: ContainerTypeInfoModel[] = [];
  private releasedContainerTypes: ContainerTypeInfoModel[] = [];
  private henganLoadingPlanSinglePlaceContainerTypeInfos: ReleasedContainerTypeInfoModel[] = [];
  private factoryLoadingPlanSinglePlaceContainerTypeInfos: ReleasedContainerTypeInfoModel[] = [];
  private multiPlacesContainerTypeInfos: ContainerTypeInfoModel[] = [];
  private selectedContainerTypes: ContainerTypeInfoModel[] = [];
  private currentRow: ContainerTypeInfoModel;

  LOADING_PLAN_TYPE_DICT = {
    HENGAN_LOADING_PLAN: {
      label: "出库计划"
    },
    FACTORY_LOADING_PLAN: {
      label: "报关计划"
    }
  };


  @Watch("data", { deep: true, immediate: true })
  private convertData() {
    this.headerInfo = { ...this.data };
    this.unreleasedContainerTypes = this.data.unreleasedContainerTypes.map(value => {
      return { ...value };
    });
    this.releasedContainerTypes = this.data.releasedContainerTypes.map(value => {
      return { ...value };
    });
    this.multiPlacesContainerTypeInfos = this.data.releasedToMorePlacesContainerTypes.map(value => {
      return { ...value };
    });
    console.log("multiPlacesContainerTypeInfos", this.multiPlacesContainerTypeInfos)
    this.henganLoadingPlanSinglePlaceContainerTypeInfos = this.data.releasedToOnePlaceContainerTypes
        .filter(value => value.type.name === "HENGAN_LOADING_PLAN").filter(value => value.containerTypes.length > 0);
    this.factoryLoadingPlanSinglePlaceContainerTypeInfos = this.data.releasedToOnePlaceContainerTypes
        .filter(value => value.type.name === "FACTORY_LOADING_PLAN").filter(value => value.containerTypes.length > 0);
  }

  private handleSelectionChange(rows: ContainerTypeInfoModel[]) {
    this.selectedContainerTypes = rows;
  }

  private releaseContainerType(row: ContainerTypeInfoModel) {
    if (row) {
      this.$emit("release-container-type", [{ id: row.id, loadingInOneOrMorePlaces: row.loadingInOneOrMorePlaces }]);
    } else {
      this.$emit("release-container-type", this.selectedContainerTypes);
    }
  }

  private removeContainerType(row: ContainerTypeInfoModel) {
    this.$emit("remove-container-type", row.id);
  }

  private changeLoadingType(row: ContainerTypeInfoModel) {
    this.$emit("change-loading-type", row.id, row.loadingInOneOrMorePlaces);
  }

  private async doAddRemark(row: ContainerTypeInfoModel) {
    await updateContainerTypeRemark(row.id, { remark: row.remark });
    // await this.getList();
  }
}

class HeaderInfo {
  id: string;
  code: string;
  customerAbbreviation: string;
  totalVolume: string;
  inStorageVolume: string;
  shippingOrderCode: string;
  totalContainerTypeQuantity: number;
  releasedContainerTypeQuantity: number;
  unreleasedContainerTypeQuantity: number;
}

export class ContainerTypeReleasedInfoModel {
  id: string;
  code: string;
  customerAbbreviation: string;
  totalVolume: string;
  inStorageVolume: string;
  shippingOrderCode: string;
  totalContainerTypeQuantity: number;
  releasedContainerTypeQuantity: number;
  unreleasedContainerTypeQuantity: number;
  unreleasedContainerTypes: ContainerTypeInfoModel[] = [];
  releasedContainerTypes: ContainerTypeInfoModel[] = [];
  releasedToMorePlacesContainerTypes: ContainerTypeInfoModel[] = [];
  releasedToOnePlaceContainerTypes: ReleasedContainerTypeInfoModel[] = [];
}

class ContainerTypeInfoModel {
  id: string;
  code: string;
  containerNumber: string;
  sealNumber: string;
  loadingInOneOrMorePlaces: string;
  serialNumber: string;
  loadingPlanId: string;
  loadingPlanCode: string;
  remark: string;
  factoryLoadingPlans: LoadingPlanCode[] = [];
  henganLoadingPlans: LoadingPlanCode[] = [];
}

class LoadingPlanCode {
  id: string;
  code: string;
}

class Type {
  name: string;
  desc: string;
}
class ReleasedContainerTypeInfoModel {
  id: string;
  code: string;
  type: Type;
  quantity: number;
  containerTypes: ContainerTypeInfoModel[] = [];
}
